import React from 'react';
import Icon from '../../../components/AppIcon';

const IntegrationStatus = () => {
  const integrations = [
    {
      name: 'Scheduling System',
      status: 'connected',
      lastSync: '2 minutes ago',
      icon: 'Calendar'
    },
    {
      name: 'Payroll Platform',
      status: 'connected',
      lastSync: '5 minutes ago',
      icon: 'DollarSign'
    },
    {
      name: 'Compliance Database',
      status: 'connected',
      lastSync: '1 minute ago',
      icon: 'Shield'
    },
    {
      name: 'Fleet Tracking',
      status: 'syncing',
      lastSync: 'Syncing now',
      icon: 'MapPin'
    }
  ];

  const getStatusColor = (status) => {
    return status === 'connected' ?'bg-success/10 text-success border-success/20' :'bg-warning/10 text-warning border-warning/20';
  };

  const getStatusIcon = (status) => {
    return status === 'connected' ? 'CheckCircle2' : 'RefreshCw';
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1 p-4">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Zap" size={18} color="var(--color-primary)" strokeWidth={2} />
        <h3 className="text-sm font-semibold text-foreground">System Integrations</h3>
      </div>
      <div className="space-y-3">
        {integrations?.map((integration, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg">
                <Icon name={integration?.icon} size={16} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{integration?.name}</p>
                <p className="text-xs text-muted-foreground">Last sync: {integration?.lastSync}</p>
              </div>
            </div>
            <span className={`inline-flex items-center space-x-1 px-2 py-1 text-xs font-medium rounded-md border ${getStatusColor(integration?.status)}`}>
              <Icon 
                name={getStatusIcon(integration?.status)} 
                size={12} 
                strokeWidth={2}
                className={integration?.status === 'syncing' ? 'animate-spin' : ''}
              />
              <span className="capitalize">{integration?.status}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationStatus;